import {DialogFragment, PageFragment, PageFragmentProps} from "@/shared/PageFragment";
import {Box} from "@mui/material";
import {FormGenContainer} from "@/shared/FormGenContainer";
import {DW_LG} from "@/shared/dimens";
import {BaseApp, DIALOG_FLAG_DISABLE_BACKDROP_CLICK, DIALOG_FLAG_SHOW_CLOSE} from "@/shared/BaseApp";
import React from "react";
import {LabelerAssignment, ResourceData} from "@/fyneai-shared/types";

export class EditAssignmentHelper {

  static editAssignment(item: LabelerAssignment) {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditLabelerAssignmentFragment
        edit={item}
        onLabelerAssignmentSaved={item => BaseApp.CONTEXT.hideDialog()}/>);
  }
}

type EditLabelerAssignmentFragmentProps = PageFragmentProps & {
  edit: LabelerAssignment,
  onLabelerAssignmentSaved: (item: LabelerAssignment) => void,
}

class EditLabelerAssignmentFragment extends DialogFragment<EditLabelerAssignmentFragmentProps> {

  private readonly labelerAssignments = ResourceData.project().labeler.assignments;
  private readonly labelerAssignment = this.props.edit;

  protected onCreateState() {
    return {
      ...super.onCreateState(),
      title: "Edit assignment",
    };
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_ACTION_PANEL_TYPE_BUTTON_FLAG;
  }

  protected getActionButtonText(): string {
    return "Save";
  }

  onActionButtonClicked() {
    this.saveLabelerAssignment().then(() => this.props.onLabelerAssignmentSaved(this.labelerAssignment));
  }

  private async saveLabelerAssignment() {
    await this.labelerAssignments.addListItem(this.labelerAssignment);
  }

  renderContent(): React.ReactElement | null {
    return <Box style={{display: "flex", width: DW_LG}}>
      <FormGenContainer
        content={this.labelerAssignment}
        saveActionButtonProvider={this}/>
    </Box>;
  }
}
